export default __webpack_public_path__ + "static/media/netlify.de3909a8.svg";